import { render, staticRenderFns } from "./Especialidades.vue?vue&type=template&id=0cd4644e&"
import script from "./Especialidades.vue?vue&type=script&lang=js&"
export * from "./Especialidades.vue?vue&type=script&lang=js&"
import style0 from "./Especialidades.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QBreadcrumbs,QBreadcrumbsEl,QSpace,QBtn,QTable,QCard,QItem,QItemSection,QAvatar,QItemLabel,QSeparator,QCardSection,QImg,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QBreadcrumbs,QBreadcrumbsEl,QSpace,QBtn,QTable,QCard,QItem,QItemSection,QAvatar,QItemLabel,QSeparator,QCardSection,QImg,QCardActions})
